/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// @ts-ignore
import type { ConfigurationParameters } from '../configuration';
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from '../configuration';
// @ts-ignore
import type { AxiosError, AxiosResponse } from 'axios';
import {
    useQuery,
    UseMutationOptions,
    useMutation,
    UseQueryOptions
    // @ts-ignore
} from 'react-query';
// @ts-ignore
import { useAuthorizationToken, useAuthQueryKey, useApiBasePath } from '../../utils';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { FlightsUpdateDto } from '../models';
// @ts-ignore
import { GanttDto } from '../models';
// @ts-ignore
import { ResourceAllocationRequestDto } from '../models';
// @ts-ignore
import { ResourceAllocationResponse } from '../models';
// @ts-ignore
import { ResourceAllocationValidationDto } from '../models';
// @ts-ignore
import { ResourceType } from '../models';
/**
 * RmsFlightWebServicesApi - axios parameter creator
 * @export
 */
export const RmsFlightWebServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} selectedDay
         * @param {ResourceType} selectedResourceType
         * @param {ResourceAllocationRequestDto} resourceAllocationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlightResourcesAllocation: async (
            selectedDay: string,
            selectedResourceType: ResourceType,
            resourceAllocationRequestDto: ResourceAllocationRequestDto,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'selectedDay' is not null or undefined
            assertParamExists('createFlightResourcesAllocation', 'selectedDay', selectedDay);
            // verify required parameter 'selectedResourceType' is not null or undefined
            assertParamExists('createFlightResourcesAllocation', 'selectedResourceType', selectedResourceType);
            // verify required parameter 'resourceAllocationRequestDto' is not null or undefined
            assertParamExists(
                'createFlightResourcesAllocation',
                'resourceAllocationRequestDto',
                resourceAllocationRequestDto
            );
            const localVarPath = `/rmsflights/allocate/{selectedDay}/{selectedResourceType}`
                .replace(`{${'selectedDay'}}`, encodeURIComponent(String(selectedDay)))
                .replace(`{${'selectedResourceType'}}`, encodeURIComponent(String(selectedResourceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                resourceAllocationRequestDto,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} selectedDay
         * @param {ResourceType} selectedResourceType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlights: async (
            selectedDay: string,
            selectedResourceType: ResourceType,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'selectedDay' is not null or undefined
            assertParamExists('getFlights', 'selectedDay', selectedDay);
            // verify required parameter 'selectedResourceType' is not null or undefined
            assertParamExists('getFlights', 'selectedResourceType', selectedResourceType);
            const localVarPath = `/rmsflights/{selectedDay}/{selectedResourceType}`
                .replace(`{${'selectedDay'}}`, encodeURIComponent(String(selectedDay)))
                .replace(`{${'selectedResourceType'}}`, encodeURIComponent(String(selectedResourceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} selectedDay
         * @param {ResourceType} selectedResourceType
         * @param {FlightsUpdateDto} flightsUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResourcesFlights: async (
            selectedDay: string,
            selectedResourceType: ResourceType,
            flightsUpdateDto: FlightsUpdateDto,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'selectedDay' is not null or undefined
            assertParamExists('updateResourcesFlights', 'selectedDay', selectedDay);
            // verify required parameter 'selectedResourceType' is not null or undefined
            assertParamExists('updateResourcesFlights', 'selectedResourceType', selectedResourceType);
            // verify required parameter 'flightsUpdateDto' is not null or undefined
            assertParamExists('updateResourcesFlights', 'flightsUpdateDto', flightsUpdateDto);
            const localVarPath = `/rmsflights/update/{selectedDay}/{selectedResourceType}`
                .replace(`{${'selectedDay'}}`, encodeURIComponent(String(selectedDay)))
                .replace(`{${'selectedResourceType'}}`, encodeURIComponent(String(selectedResourceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                flightsUpdateDto,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} selectedDay
         * @param {ResourceType} selectedResourceType
         * @param {ResourceAllocationValidationDto} resourceAllocationValidationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateResourcesAllocationFlights: async (
            selectedDay: string,
            selectedResourceType: ResourceType,
            resourceAllocationValidationDto: ResourceAllocationValidationDto,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'selectedDay' is not null or undefined
            assertParamExists('validateResourcesAllocationFlights', 'selectedDay', selectedDay);
            // verify required parameter 'selectedResourceType' is not null or undefined
            assertParamExists('validateResourcesAllocationFlights', 'selectedResourceType', selectedResourceType);
            // verify required parameter 'resourceAllocationValidationDto' is not null or undefined
            assertParamExists(
                'validateResourcesAllocationFlights',
                'resourceAllocationValidationDto',
                resourceAllocationValidationDto
            );
            const localVarPath = `/rmsflights/validate/{selectedDay}/{selectedResourceType}`
                .replace(`{${'selectedDay'}}`, encodeURIComponent(String(selectedDay)))
                .replace(`{${'selectedResourceType'}}`, encodeURIComponent(String(selectedResourceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                resourceAllocationValidationDto,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};

/**
 * RmsFlightWebServicesApi - functional programming interface
 * @export
 */
export const RmsFlightWebServicesApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = RmsFlightWebServicesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} selectedDay
         * @param {ResourceType} selectedResourceType
         * @param {ResourceAllocationRequestDto} resourceAllocationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFlightResourcesAllocation(
            selectedDay: string,
            selectedResourceType: ResourceType,
            resourceAllocationRequestDto: ResourceAllocationRequestDto,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceAllocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFlightResourcesAllocation(
                selectedDay,
                selectedResourceType,
                resourceAllocationRequestDto,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} selectedDay
         * @param {ResourceType} selectedResourceType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlights(
            selectedDay: string,
            selectedResourceType: ResourceType,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GanttDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlights(
                selectedDay,
                selectedResourceType,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} selectedDay
         * @param {ResourceType} selectedResourceType
         * @param {FlightsUpdateDto} flightsUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateResourcesFlights(
            selectedDay: string,
            selectedResourceType: ResourceType,
            flightsUpdateDto: FlightsUpdateDto,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GanttDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateResourcesFlights(
                selectedDay,
                selectedResourceType,
                flightsUpdateDto,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} selectedDay
         * @param {ResourceType} selectedResourceType
         * @param {ResourceAllocationValidationDto} resourceAllocationValidationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateResourcesAllocationFlights(
            selectedDay: string,
            selectedResourceType: ResourceType,
            resourceAllocationValidationDto: ResourceAllocationValidationDto,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GanttDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateResourcesAllocationFlights(
                selectedDay,
                selectedResourceType,
                resourceAllocationValidationDto,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        }
    };
};

/**
 * RmsFlightWebServicesApi - factory interface
 * @export
 */
export const RmsFlightWebServicesApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) {
    const localVarFp = RmsFlightWebServicesApiFp(configuration);
    return {
        /**
         *
         * @param {RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlightResourcesAllocation(
            requestParameters: RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<ResourceAllocationResponse> {
            return localVarFp
                .createFlightResourcesAllocation(
                    requestParameters.selectedDay,
                    requestParameters.selectedResourceType,
                    requestParameters.resourceAllocationRequestDto,
                    options
                )
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RmsFlightWebServicesApiGetFlightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlights(
            requestParameters: RmsFlightWebServicesApiGetFlightsRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<GanttDto> {
            return localVarFp
                .getFlights(requestParameters.selectedDay, requestParameters.selectedResourceType, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RmsFlightWebServicesApiUpdateResourcesFlightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResourcesFlights(
            requestParameters: RmsFlightWebServicesApiUpdateResourcesFlightsRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<GanttDto> {
            return localVarFp
                .updateResourcesFlights(
                    requestParameters.selectedDay,
                    requestParameters.selectedResourceType,
                    requestParameters.flightsUpdateDto,
                    options
                )
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateResourcesAllocationFlights(
            requestParameters: RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<GanttDto> {
            return localVarFp
                .validateResourcesAllocationFlights(
                    requestParameters.selectedDay,
                    requestParameters.selectedResourceType,
                    requestParameters.resourceAllocationValidationDto,
                    options
                )
                .then(request => request(axios, basePath));
        }
    };
};

/**
 * Request parameters for createFlightResourcesAllocation operation in RmsFlightWebServicesApi.
 * @export
 * @interface RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest
 */
export interface RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest {
    /**
     *
     * @type {string}
     * @memberof RmsFlightWebServicesApiCreateFlightResourcesAllocation
     */
    readonly selectedDay: string;

    /**
     *
     * @type {ResourceType}
     * @memberof RmsFlightWebServicesApiCreateFlightResourcesAllocation
     */
    readonly selectedResourceType: ResourceType;

    /**
     *
     * @type {ResourceAllocationRequestDto}
     * @memberof RmsFlightWebServicesApiCreateFlightResourcesAllocation
     */
    readonly resourceAllocationRequestDto: ResourceAllocationRequestDto;
}

/**
 * Request parameters for getFlights operation in RmsFlightWebServicesApi.
 * @export
 * @interface RmsFlightWebServicesApiGetFlightsRequest
 */
export interface RmsFlightWebServicesApiGetFlightsRequest {
    /**
     *
     * @type {string}
     * @memberof RmsFlightWebServicesApiGetFlights
     */
    readonly selectedDay: string;

    /**
     *
     * @type {ResourceType}
     * @memberof RmsFlightWebServicesApiGetFlights
     */
    readonly selectedResourceType: ResourceType;
}

/**
 * Request parameters for updateResourcesFlights operation in RmsFlightWebServicesApi.
 * @export
 * @interface RmsFlightWebServicesApiUpdateResourcesFlightsRequest
 */
export interface RmsFlightWebServicesApiUpdateResourcesFlightsRequest {
    /**
     *
     * @type {string}
     * @memberof RmsFlightWebServicesApiUpdateResourcesFlights
     */
    readonly selectedDay: string;

    /**
     *
     * @type {ResourceType}
     * @memberof RmsFlightWebServicesApiUpdateResourcesFlights
     */
    readonly selectedResourceType: ResourceType;

    /**
     *
     * @type {FlightsUpdateDto}
     * @memberof RmsFlightWebServicesApiUpdateResourcesFlights
     */
    readonly flightsUpdateDto: FlightsUpdateDto;
}

/**
 * Request parameters for validateResourcesAllocationFlights operation in RmsFlightWebServicesApi.
 * @export
 * @interface RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest
 */
export interface RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest {
    /**
     *
     * @type {string}
     * @memberof RmsFlightWebServicesApiValidateResourcesAllocationFlights
     */
    readonly selectedDay: string;

    /**
     *
     * @type {ResourceType}
     * @memberof RmsFlightWebServicesApiValidateResourcesAllocationFlights
     */
    readonly selectedResourceType: ResourceType;

    /**
     *
     * @type {ResourceAllocationValidationDto}
     * @memberof RmsFlightWebServicesApiValidateResourcesAllocationFlights
     */
    readonly resourceAllocationValidationDto: ResourceAllocationValidationDto;
}

/**
 * RmsFlightWebServicesApi - object-oriented interface
 * @export
 * @class RmsFlightWebServicesApi
 * @extends {BaseAPI}
 */
export class RmsFlightWebServicesApi extends BaseAPI {
    /**
     *
     * @param {RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RmsFlightWebServicesApi
     */
    public createFlightResourcesAllocation(
        requestParameters: RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest,
        options?: AxiosRequestConfig
    ) {
        return RmsFlightWebServicesApiFp(this.configuration)
            .createFlightResourcesAllocation(
                requestParameters.selectedDay,
                requestParameters.selectedResourceType,
                requestParameters.resourceAllocationRequestDto,
                options
            )
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RmsFlightWebServicesApiGetFlightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RmsFlightWebServicesApi
     */
    public getFlights(requestParameters: RmsFlightWebServicesApiGetFlightsRequest, options?: AxiosRequestConfig) {
        return RmsFlightWebServicesApiFp(this.configuration)
            .getFlights(requestParameters.selectedDay, requestParameters.selectedResourceType, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RmsFlightWebServicesApiUpdateResourcesFlightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RmsFlightWebServicesApi
     */
    public updateResourcesFlights(
        requestParameters: RmsFlightWebServicesApiUpdateResourcesFlightsRequest,
        options?: AxiosRequestConfig
    ) {
        return RmsFlightWebServicesApiFp(this.configuration)
            .updateResourcesFlights(
                requestParameters.selectedDay,
                requestParameters.selectedResourceType,
                requestParameters.flightsUpdateDto,
                options
            )
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RmsFlightWebServicesApi
     */
    public validateResourcesAllocationFlights(
        requestParameters: RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest,
        options?: AxiosRequestConfig
    ) {
        return RmsFlightWebServicesApiFp(this.configuration)
            .validateResourcesAllocationFlights(
                requestParameters.selectedDay,
                requestParameters.selectedResourceType,
                requestParameters.resourceAllocationValidationDto,
                options
            )
            .then(request => request(this.axios, this.basePath));
    }
}

// custom hook generation here
export type PostCreateFlightResourcesAllocationResponse = AxiosResponse<ResourceAllocationResponse>;
export const KeyPostCreateFlightResourcesAllocation = 'PostCreateFlightResourcesAllocation';
export const useMutationPostCreateFlightResourcesAllocation = (
    options?: UseMutationOptions<
        PostCreateFlightResourcesAllocationResponse,
        AxiosError,
        RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        PostCreateFlightResourcesAllocationResponse,
        AxiosError,
        RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest
    >(
        (args: RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest) =>
            new RmsFlightWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).createFlightResourcesAllocation(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPostCreateFlightResourcesAllocation = (
    args: RmsFlightWebServicesApiCreateFlightResourcesAllocationRequest,
    options?: UseQueryOptions<PostCreateFlightResourcesAllocationResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PostCreateFlightResourcesAllocationResponse, AxiosError>(
        [KeyPostCreateFlightResourcesAllocation, args, options && options.queryKey, authQueryKey],
        () =>
            new RmsFlightWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).createFlightResourcesAllocation(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetFlightsResponse = AxiosResponse<GanttDto>;
export const KeyGetGetFlights = 'GetGetFlights';
export const useMutationGetGetFlights = (
    options?: UseMutationOptions<GetGetFlightsResponse, AxiosError, RmsFlightWebServicesApiGetFlightsRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetFlightsResponse, AxiosError, RmsFlightWebServicesApiGetFlightsRequest>(
        (args: RmsFlightWebServicesApiGetFlightsRequest) =>
            new RmsFlightWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getFlights(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetFlights = (
    args: RmsFlightWebServicesApiGetFlightsRequest,
    options?: UseQueryOptions<GetGetFlightsResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetFlightsResponse, AxiosError>(
        [KeyGetGetFlights, args, options && options.queryKey, authQueryKey],
        () =>
            new RmsFlightWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getFlights(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type PutUpdateResourcesFlightsResponse = AxiosResponse<GanttDto>;
export const KeyPutUpdateResourcesFlights = 'PutUpdateResourcesFlights';
export const useMutationPutUpdateResourcesFlights = (
    options?: UseMutationOptions<
        PutUpdateResourcesFlightsResponse,
        AxiosError,
        RmsFlightWebServicesApiUpdateResourcesFlightsRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        PutUpdateResourcesFlightsResponse,
        AxiosError,
        RmsFlightWebServicesApiUpdateResourcesFlightsRequest
    >(
        (args: RmsFlightWebServicesApiUpdateResourcesFlightsRequest) =>
            new RmsFlightWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).updateResourcesFlights(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPutUpdateResourcesFlights = (
    args: RmsFlightWebServicesApiUpdateResourcesFlightsRequest,
    options?: UseQueryOptions<PutUpdateResourcesFlightsResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PutUpdateResourcesFlightsResponse, AxiosError>(
        [KeyPutUpdateResourcesFlights, args, options && options.queryKey, authQueryKey],
        () =>
            new RmsFlightWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).updateResourcesFlights(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type PutValidateResourcesAllocationFlightsResponse = AxiosResponse<GanttDto>;
export const KeyPutValidateResourcesAllocationFlights = 'PutValidateResourcesAllocationFlights';
export const useMutationPutValidateResourcesAllocationFlights = (
    options?: UseMutationOptions<
        PutValidateResourcesAllocationFlightsResponse,
        AxiosError,
        RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        PutValidateResourcesAllocationFlightsResponse,
        AxiosError,
        RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest
    >(
        (args: RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest) =>
            new RmsFlightWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).validateResourcesAllocationFlights(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPutValidateResourcesAllocationFlights = (
    args: RmsFlightWebServicesApiValidateResourcesAllocationFlightsRequest,
    options?: UseQueryOptions<PutValidateResourcesAllocationFlightsResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PutValidateResourcesAllocationFlightsResponse, AxiosError>(
        [KeyPutValidateResourcesAllocationFlights, args, options && options.queryKey, authQueryKey],
        () =>
            new RmsFlightWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).validateResourcesAllocationFlights(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
